export const homeIntroductions = [
  {
    title: '眼镜佩戴说明',
    content: [
      '1. 如有矫正眼镜，训练全程需要佩戴矫正眼镜。',
      '2. 是否佩戴红蓝眼镜，请根据每个训练的提示佩戴。',
      '3. 佩戴红蓝眼镜的训练，都无需进行遮盖。',
      '4. 保持眼睛平视屏幕，且距离在45CM以上。',
      // '5. 如有医嘱，请遵医嘱。',
    ],
    bgImage: 'images/home-glasses.png',
  },
  // {
  //   title: '建议训练时间',
  //   content: [
  //     '1. 近视型弱视患者：每天训练2次，每次训练10分钟。',
  //     '2. 远视型弱视患者：每天训练2次，每次训练20分钟。',
  //     '3. 斜视术前、术后患者：每天训练2次，每次训练20分钟。',
  //     '4. 眼球震颤、先天性白内障患者：每天训练2次，每次训练20分钟。',
  //     '5. 如有医嘱，请遵医嘱。',
  //   ],
  //   bgImage: 'images/home-time.png',
  // },
  {
    title: '训练小贴士',
    content: [
      '1. 家长的陪伴、引导、鼓励和坚持非常重要。孩子能否坚持训练，是视力、视功能恢复的重要条件。',
      '2. 必要的重复训练是康复的基础。重复同样的训练，目的在于频繁刺激神经通道并巩固视觉功能。',
      '3. 部分人群在视力达到一定程度后，会进入平台期，视力提升缓慢。请坚持训练，并根据指导增加双眼视功能训练。',
    ],
    bgImage: 'images/home-train.png',
  },
  // {
  //   title: '视觉训练种类',
  //   typeList: [
  //     {
  //       typeName: '精细刺激训练',
  //       contents: [
  //         '精细刺激类训练用于提高视力。一般有多个难度，随着难度的增加，训练中的视标，以及背景的光栅、黑白格单位会越来越小。画面中闪烁的特定背景和视标会刺激视神经细胞发育，促使差眼受到不同空间频率的刺激，大脑皮质的视神经元对视觉信号的接受及处理会逐渐增强，达到快速提高视力的目的。',
  //         '精细和刺激训练一般需要遮盖好眼进行训练，无需佩戴红蓝眼镜。',
  //       ],
  //       imgList: [
  //         'images/types/cjjx1.png',
  //         'images/types/cjjx2.png',
  //         'images/types/cjjx3.png',
  //       ],
  //     },
  //     {
  //       typeName: '脱抑制同时视训练',
  //       contents: [
  //         '脱抑制训练也称为MFBF（双眼视野下的单眼训练）。是通过红蓝眼镜分视，在双眼视野下只有弱视眼能看到视标，从而让大脑逐渐解除对差眼的抑制。同时视是三级视功能第一级，通过分视眼镜让每只眼看到不同的视标，逐渐去除优势眼对弱视眼的抑制，建立正常的双眼视野。',
  //         '脱抑制同时视训练无需遮盖，但需要佩戴红蓝眼镜。',
  //       ],
  //       imgList: [
  //         'images/types/tyztss1.png',
  //         'images/types/tyztss2.png',
  //         'images/types/tyztss3.png',
  //       ],
  //     },
  //     {
  //       typeName: '融合立体视',
  //       contents: [
  //         '融合视是三级视功能第二级，是指同一物体在双眼视网膜上合像的能力。融合异常时会产生复视、混淆视或斜视。融合训练利用多种运动方式诱导双眼产生融合、扩大融合范围，有效缓解视疲劳。立体视是三级视功能最后一级，指视皮层将双眼有视差的物象形成立体感的能力。立体视训练利用物象偏移形成立体感/深度感，让大脑反复进行强立体感和弱立体感的比较判断，逐渐完成立体感知能力的建立。',
  //         '融合立体视训练无需遮盖，但需要佩戴红蓝眼镜',
  //       ],
  //       imgList: [
  //         'images/types/rhlts1.png',
  //         'images/types/rhlts2.png',
  //         'images/types/rhlts3.png',
  //       ],
  //     },
  //   ],
  //   bgImage: 'images/home-type.png',
  // },
  { title: '微信指导', bgImage: 'images/home-wechat.png' },
]

export const accIntroductions = [
  {
    title: '什么是调节训练？',
    content: [
      '人眼的调节能力，就跟相机的对焦能力一样，可以使我们既能看清近处的物体，又能看清远处的物体。调节能力异常可以分为调节不足、调节过度、调节麻痹、调节不持久、双眼调节不等、调节灵敏度异常等。常见问题包括远近视力模糊、阅读难以集中、近距离眼疲劳，长时间用眼后出现干涩、酸胀，甚至头晕等。',
      '调节训练是眼部肌肉及视知觉的健身，主通过双面镜的正负镜片做对应的训练，增强调节能力，改善视疲劳，提升阅读效率，提高专注力水平，缓解眼部不适。',
      '调节训练需要配合翻转镜进行，翻转镜又称双面镜，翻转拍。主要有以下三种：',
      [
        { image: 'images/hand-flipper.png', text: '手持式传统翻转镜' },
        { image: 'images/auto-flipper.png', text: '台式自动翻转镜' },
        { image: 'images/head-flipper.png', text: '头戴式自动翻转镜' },
      ],
    ],
    bgImage: 'images/sdx-acc.png',
  },
  {
    title: '哪里购买翻转镜？',
    content: [{ image: 'images/weidian.png', text: '微信扫码进入微店' }],
    bgImage: 'images/sdx-shop.png',
  },
  {
    title: '下载打印版训练卡',
    content: [
      { image: '', text: '1. 关注视多宝微信公众号' },
      { image: 'images/weixin.png', text: '2. 回复关键词：调节训练卡' },
      { image: 'images/weixin2.png', text: '' },
    ],
    bgImage: 'images/sdx-card.png',
  },
  {
    title: '联系视多宝',
    content: [{ image: 'images/kefu.png', text: '微信扫码联系视多宝客服' }],
    bgImage: 'images/sdx-connect-us.png',
  },
]
